import { InjectionToken } from '@angular/core';
export const AppName = new InjectionToken<string>('AppName');
export const RootUrl = new InjectionToken<string>('RootUrl');
